// frontend/src/components/setup/LoadingLine.tsx
import type { ReactNode } from "react";
import { Loader2 } from "lucide-react";
import { cn } from "@/lib/utils";

/** Setup's loading message: a tinted band with a spinner, and a bar when the count is known. */
export function LoadingLine({ children, progress, className }: {
  children: ReactNode;
  progress?: { done: number; total: number };
  className?: string;
}) {
  const pct = progress && progress.total > 0
    ? Math.round((100 * Math.min(progress.done, progress.total)) / progress.total)
    : null;
  return (
    <div role="status" aria-live="polite"
      className={cn("flex flex-col gap-2 rounded-md border border-primary/40 bg-primary/10 px-3 py-2", className)}>
      <div className="flex items-center gap-2 text-sm text-foreground">
        <Loader2 aria-hidden className="size-4 shrink-0 text-primary motion-safe:animate-spin" />
        <span>{children}</span>
      </div>
      {progress && pct !== null && (
        <div role="progressbar" aria-valuemin={0} aria-valuemax={progress.total} aria-valuenow={progress.done}
          className="h-1 overflow-hidden rounded-full bg-primary/15">
          <div className="h-full rounded-full bg-primary transition-[width]" style={{ width: `${pct}%` }} />
        </div>
      )}
    </div>
  );
}
